'use client';

import { ETIQUETA_TIPO_PLAN, PESTANAS_TIPO_PLAN, type VistaPrecios } from './textosSeccionPrecios';

interface PropiedadesSelectorTipoPlan {
    vista: VistaPrecios;
    alCambiar: (vista: VistaPrecios) => void;
}

const CLASE_BOTON = 'min-h-11 flex-1 whitespace-nowrap rounded-[10px] px-5 text-ds-300 font-bold';
const CLASE_PULSADO = 'bg-ink text-canvas';
const CLASE_SUELTO = 'bg-transparent text-ink';

/**
 * El selector «Para ti / Para tu clínica» (UI-SPEC §Interaction 5). Botones con `aria-pressed`
 * y no pestañas: no hay panel con nombre propio que controlar, solo cambia el juego de tarjetas,
 * y así Tab recorre los dos botones como en el lienzo. 420 px centrado en escritorio y todo el
 * ancho en móvil.
 */
export default function SelectorTipoPlan({ vista, alCambiar }: PropiedadesSelectorTipoPlan) {
    return (
        <div
            role="group"
            aria-label={ETIQUETA_TIPO_PLAN}
            className="box-border flex w-full gap-1 rounded-[14px] border-2 border-ink bg-surface-2 p-1 shadow-ds-2 lg:w-[420px] lg:self-center"
        >
            {PESTANAS_TIPO_PLAN.map((pestana) => (
                <button
                    key={pestana.vista}
                    type="button"
                    aria-pressed={vista === pestana.vista}
                    onClick={() => alCambiar(pestana.vista)}
                    className={`${CLASE_BOTON} ${vista === pestana.vista ? CLASE_PULSADO : CLASE_SUELTO}`}
                >
                    {pestana.texto}
                </button>
            ))}
        </div>
    );
}
